const getUserLocale = () => {
  const languageCode =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage ||
    'en-us';
  const languageCodeParts = languageCode.toLowerCase().split(/[_-]+/);
  const language = languageCodeParts[0];
  const region = languageCodeParts[1] || 'us';

  return `${language}-${region}`;
};

export { getUserLocale };



// WEBPACK FOOTER //
// ./src/apis/LocalizationApi.js